import React, { Fragment, useState, useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import LocaleStrings from "../../languages/index";
import _ from "lodash";
import { classNames } from "../Common/constant";
import { Transition, Dialog, RadioGroup } from "@headlessui/react";
import { XIcon } from "@heroicons/react/outline";
import { languageModalOpen, setLocaleLanguage } from "../../actions";

const settings = [
  { name: "(en)", description: "English" },
  { name: "(ar)", description: "عربى" },
];
function Language(props) {
  const { languageModal, localLanguage, session } = props;
  const [selected, setSelected] = useState(settings[0]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (localLanguage === "ar") {
      setSelected(settings[1]);
    } else {
      setSelected(settings[0]);
    }
  }, []);

  const closeModal1 = () => {};

  const closeModal = () => {
    // Clear Single Discount Object (Pointing to)
    props.languageModalOpen(false);
  };

  const onRadioChange = (e) => {
    setSelected(e);
  };

  const saveLanguage = () => {
    setLoading(true);
    let lang = "";
    //console.log({ selected });
    if (selected.name === "(en)") {
      lang = "en";
    } else {
      lang = "ar";
    }
    props.setLocaleLanguage(session, lang, (res) => {
      setLoading(false);

      closeModal();
    });
  };

  console.log("pop localLanguage", localLanguage);
  return (
    <>
      <Transition.Root show={languageModal} as={Fragment}>
        <Dialog
          // initialFocus={this.myRef}
          as="div"
          static
          className="fixed z-10 inset-0 overflow-y-auto"
          open={languageModal}
          onClose={closeModal1}
        >
          <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0 bg-ternary bg-opacity-75 transition-opacity" />
            </Transition.Child>
            <span
              className="hidden sm:inline-block sm:align-middle sm:h-screen"
              aria-hidden="true"
            >
              &#8203;
            </span>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <div
                className="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6 sticky-top scrollbar-hide"
                style={{ padding: 0, width: "100%" }}
              >
                {/* MOdal Header */}
                <div className="grid grid-cols-2 border-b border-primary pb-4 sticky-header z-10">
                  <div className="col-span-2 flex flex-wrap justify-start md:justify-center mt-4 pl-4">
                    <div className="text-lg leading-6 font-medium text-ads">
                      {LocaleStrings.select_language}
                    </div>
                  </div>
                  <div className="block absolute top-0 right-0 pt-4 pr-4 ">
                    <button
                      type="button"
                      className="btn-closeModal focus:outline-none"
                      onClick={() => closeModal()}
                    >
                      <span className="sr-only">{LocaleStrings.close}</span>
                      <XIcon className="h-6 w-6" aria-hidden="true" />
                    </button>
                  </div>
                </div>
                {/* Modal Body */}

                <div className="mx-6 mt-2">
                  <div className="py-4">
                    <RadioGroup
                      value={selected}
                      onChange={(e) => onRadioChange(e)}
                    >
                      <RadioGroup.Label className="sr-only"></RadioGroup.Label>
                      <div className="bg-white rounded-md -space-y-px">
                        {settings.map((setting, settingIdx) => (
                          <RadioGroup.Option
                            key={setting.name}
                            value={setting}
                            className={({ checked }) =>
                              classNames(
                                settingIdx === 0
                                  ? "rounded-tl-md rounded-tr-md"
                                  : "",
                                settingIdx === settings.length - 1
                                  ? "rounded-bl-md rounded-br-md"
                                  : "",
                                checked
                                  ? "bg-primaryLight z-10"
                                  : "border-gray-200",
                                "relative border p-4 flex cursor-pointer focus:outline-none"
                              )
                            }
                          >
                            {({ active, checked }) => (
                              <>
                                <span
                                  className={classNames(
                                    checked
                                      ? "bg-btn border-transparent"
                                      : "bg-white border-gray-300",
                                    active
                                      ? "ring-2 ring-offset-2 ring-primaty"
                                      : "",
                                    "h-4 w-4 mt-0.5 cursor-pointer rounded-full border flex items-center justify-center"
                                  )}
                                  aria-hidden="true"
                                >
                                  <span className="rounded-full bg-white w-1.5 h-1.5" />
                                </span>
                                <div className="mx-3 flex flex-col">
                                  <RadioGroup.Label
                                    as="span"
                                    className={classNames(
                                      checked ? "text-ads" : "text-primary",
                                      "block text-sm font-medium"
                                    )}
                                  >
                                    {setting.name}
                                  </RadioGroup.Label>
                                  <RadioGroup.Description
                                    as="span"
                                    className={classNames(
                                      checked ? "text-ads" : "text-primary",
                                      "block text-sm"
                                    )}
                                  >
                                    {setting.description}
                                  </RadioGroup.Description>
                                </div>
                              </>
                            )}
                          </RadioGroup.Option>
                        ))}
                      </div>
                    </RadioGroup>
                  </div>
                  <div className="py-4">
                    <button
                      type="button"
                      className="rounded py-2 px-5 w-full flex items-center justify-center bg-btn text-white font-medium text-sm cursor-pointer"
                      onClick={() => saveLanguage()}
                    >
                      {loading ? (
                        <svg
                          className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                        >
                          <circle
                            className="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            stroke-width="4"
                          ></circle>
                          <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                          ></path>
                        </svg>
                      ) : (
                        ""
                      )}
                      {LocaleStrings.btn_save}
                    </button>
                  </div>
                </div>
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition.Root>
    </>
  );
}

const mapStateToProps = (state) => ({
  isLoggedIn: state.isLoggedIn,
  session: state.session,
  localLanguage: state.localLanguage,
  deviceSize: state.deviceSize,
  languageModal: state.languageModal,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ languageModalOpen, setLocaleLanguage }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Language);
